import { gql } from '@apollo/client';

export const GET_WORKFLOW_REQUESTS = gql`
  query getWorkflowRequests($pageNumber: Int!, $pageSize: Int!) {
    workflowRequests(page: { pageNumber: $pageNumber, pageSize: $pageSize }) {
      totalCount
      items {
        id
        requestType {
          code
        }
        requestDetails {
          code
          value
        }
        responses {
          code
          responseTypeCode
          responseValue
        }
        requestStatus {
          id
          code
          name
        }
        responseStatus {
          id
          code
          name
        }
        project {
          id
          name
        }
        role {
          name
        }
        owner {
          firstName
          lastName
        }
        responder {
          stageName
        }
      }
    }
  }
`;

export const MUTATION_SET_QUESTION_RESPONSE = gql`
  mutation setQuestionResponse($input: QuestionResponseInput!) {
    isSuccess: setQuestionResponse(input: $input)
  }
`;

export const MUTATION_SET_AUDITION_INVITATION_RESPONSE = gql`
  mutation setAuditionInvitationResponse($input: AuditionInvitationResponseInput!) {
    isSuccess: setAuditionInvitationResponse(input: $input)
  }
`;

export const GET_WORKFLOW_REQUEST = gql`
  query getWorkflowRequest($id: String!) {
    workflowRequest(id: $id) {
      id
      requestType {
        code
      }
      requestDetails {
        code
        value
      }
      responses {
        code
        responseTypeCode
        responseValue
      }
      requestStatus {
        id
        code
        name
      }
      responseStatus {
        id
        code
        name
      }
      project {
        id
        name
        castingDirector
        synopsis
        projectType {
          name
        }
        projectUnion {
          union {
            name
          }
        }
      }
      role {
        projectId
        id
        name
        roleType {
          name
        }
        ageMinMonth
        ageMaxMonth
        rateSummary
        description
      }
      owner {
        firstName
        lastName
      }
      responder {
        stageName
      }
    }
  }
`;
